<template>
  <div class="panel panel-default form-horizontal">
    <div class="panel-heading">
      <h5 class="pull-left">
        Advanced Setup

        <i class="fa fa-question-circle" v-tooltip.bottom="tooltip"></i>
      </h5>

      <button type="button" class="btn btn-xs btn-black pull-right" @click="display = !display" style="margin-top: 8px">
        <i class="fa fa-search"></i> {{ display ? 'Hide' : 'Show' }}
      </button>

      <div class="clearfix"></div>
    </div>

    <div v-if="display" class="panel-body">
      <RadioFormGroup
          :value="subscription.has_automatic_renewal"
          name="has_automatic_renewal"
          label="Automatic Renewal"
          help-text="Select this option if the subscription should automatically be renewed."
          :error="getError('has_automatic_renewal')"
          @input="update('has_automatic_renewal', $event)"
          :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
      />

      <RadioFormGroup
          :value="subscription.is_free"
          name="is_free"
          label="Free"
          help-text="Select this option if the subscription should be free."
          :error="getError('is_free')"
          @input="update('is_free', $event)"
          :options="[{value: true, label: 'Yes'}, {value: false, label: 'No'}]"
      />

      <TypeaheadFormGroup
          :value="subscription.other_payer_id"
          name="other_payer_id"
          label="Other Payer"
          help-text="The company that pays for the subscription (optional)."
          :error="getError('other_payer_id')"
          @input="update('other_payer_id', $event)"
          endpoint="/api/v2/companies"
          :token="shared.token"
          path="data.data"
          placeholder="Search..."
          :result-label-property="row => row.attributes.name"
      />

      <TypeaheadFormGroup
          v-model="subscription.other_payer_contact_person_id"
          name="other_payer_contact_person_id"
          label="Other Payer Contact Person"
          help-text="The contact person in the company that pays for the subscription (if not the subscriber itself)."
          :error="getError('other_payer_contact_person_id')"
          endpoint="/api/v2/people"
          :params="{'filter[company_id]': subscription.other_payer_id}"
          :token="shared.token"
          path="data.data"
          placeholder="Search..."
          :result-label-property="row => row.attributes.name"
      />

      <TypeaheadFormGroup
          v-model="subscription.user_id"
          name="user_id"
          label="User"
          endpoint="/api/v2/users"
          :token="shared.token"
          path="data.data"
          placeholder="Search..."
          :result-label-property="row => row.attributes.full_name"
          help-text="The user that is responsible for selling the subscription."
          :nullable="true"
          :load-initial="true"
      />

      <TypeaheadFormGroup
          v-model="subscription.renewal_responsible_id"
          name="renewal_responsible_id"
          label="Renewal Responsible"
          endpoint="/api/v2/users"
          :token="shared.token"
          path="data.data"
          placeholder="Search..."
          :result-label-property="row => row.attributes.full_name"
          help-text="The user that is responsible for renewing subscription (if different from the person who sells the subscription)."
          :nullable="true"
          :load-initial="true"
      />
    </div>
  </div>
</template>

<script>
import store from '@/store'
import RadioFormGroup from '@/vendor/forms/FormGroups/Horizontal/Radio'
import SelectFormGroup from '@/vendor/forms/FormGroups/Horizontal/Select'
import SelectWithButtonFormGroup from '@/components/FormGroups/Horizontal/SelectWithButton'
import TypeaheadFormGroup from '@/vendor/forms/FormGroups/Horizontal/Typeahead'

export default {
  components: {RadioFormGroup, SelectFormGroup, SelectWithButtonFormGroup, TypeaheadFormGroup},

  props: ['subscription', 'people', 'errors'],

  model: {
    prop: 'subscription'
  },

  data() {
    return {
      shared: store,
      display: false
    }
  },

  computed: {
    tooltip() {
      return {
        content: '<p>In this form, you may change some of the advanced details of the subscription, including whether to automatically renew the subscription when it ends.</p><p>You may also select another company as payer for the subscription, as well as changing the person that is responsible for the subscription.</p>',
        classes: 'help'
      }
    }
  },

  methods: {
    update(key, value) {
      this.$emit('input', {...this.subscription, [key]: value})
    },

    getError(name) {
      return typeof this.errors[name] !== 'undefined' ? this.errors[name][0] : null
    }
  }
}
</script>
